
export const FETCH_ALL_WAREHOUSE_STYLE_REQUEST = 'FETCH_ALL_WAREHOUSE_STYLE_REQUEST';
export const FETCH_ALL_WAREHOUSE_STYLE_SUCCESS = 'FETCH_ALL_WAREHOUSE_STYLE_SUCCESS';
export const FETCH_ALL_WAREHOUSE_STYLE_FAILURE = 'FETCH_ALL_WAREHOUSE_STYLE_FAILURE';


export const FETCH_BY_ID_WAREHOUSE_STYLE_REQUEST = 'FETCH_BY_ID_WAREHOUSE_STYLE_REQUEST';
export const FETCH_BY_ID_WAREHOUSE_STYLE_SUCCESS = 'FETCH_BY_ID_WAREHOUSE_STYLE_SUCCESS';
export const FETCH_BY_ID_WAREHOUSE_STYLE_FAILURE = 'FETCH_BY_ID_WAREHOUSE_STYLE_FAILURE';

export const CREATE_USERFORM_WAREHOUSE_STYLE = 'CREATE_USERFORM_WAREHOUSE_STYLE';

export const RESET_WAREHOUSE_STYLE_USERFORM = 'RESET_WAREHOUSE_STYLE_USERFORM';

export const CREATE_WAREHOUSE_STYLE_REQUEST = 'CREATE_WAREHOUSE_STYLE_REQUEST';
export const CREATE_WAREHOUSE_STYLE_SUCCESS = 'CREATE_WAREHOUSE_STYLE_SUCCESS';
export const CREATE_WAREHOUSE_STYLE_FAILURE = 'CREATE_WAREHOUSE_STYLE_FAILURE';

export const UPDATE_WAREHOUSE_STYLE_REQUEST = 'UPDATE_WAREHOUSE_STYLE_REQUEST';
export const UPDATE_WAREHOUSE_STYLE_SUCCESS = 'UPDATE_WAREHOUSE_STYLE_SUCCESS';
export const UPDATE_WAREHOUSE_STYLE_FAILURE = 'UPDATE_WAREHOUSE_STYLE_FAILURE';

export const DELETE_WAREHOUSE_STYLE_REQUEST = 'DELETE_WAREHOUSE_STYLE_REQUEST';
export const DELETE_WAREHOUSE_STYLE_SUCCESS = 'DELETE_WAREHOUSE_STYLE_SUCCESS';
export const DELETE_WAREHOUSE_STYLE_FAILURE = 'DELETE_WAREHOUSE_STYLE_FAILURE';

export const FETCH_WAREHOUSE_STYLE_INVOICE_REQUEST = 'FETCH_WAREHOUSE_STYLE_INVOICE_REQUEST';
export const FETCH_WAREHOUSE_STYLE_INVOICE_SUCCESS = 'FETCH_WAREHOUSE_STYLE_INVOICE_SUCCESS';
export const FETCH_WAREHOUSE_STYLE_INVOICE_FAILURE = 'FETCH_WAREHOUSE_STYLE_INVOICE_FAILURE';

export const NAVIGATE_WAREHOUSE_STYLE = 'NAVIGATE_WAREHOUSE_STYLE';
export const NAVIGATE_WAREHOUSE_STYLE_DETAILS = 'NAVIGATE_WAREHOUSE_STYLE_DETAILS';
export const WAREHOUSE_STYLE_USERFORM_NAVIGATE_TO_DETAIL_TAB = 'WAREHOUSE_STYLE_USERFORM_NAVIGATE_TO_DETAIL_TAB';
export const WAREHOUSE_STYLE_USERFORM_NAVIGATE_TO_DETAIL_REVERSE = 'WAREHOUSE_STYLE_USERFORM_NAVIGATE_TO_DETAIL_REVERSE';
export const NAVIGATE_WAREHOUSE_STYLE_PRINT = 'NAVIGATE_WAREHOUSE_STYLE_PRINT';
export const RESET_WAREHOUSE_STYLE_INVOICE = 'RESET_WAREHOUSE_STYLE_INVOICE';